import type { Branch } from './types'

/**
 * The main branch's row. Main is identified by its name sentinel — stable
 * because protected rows can't be renamed and main can never be unprotected.
 * Never use `protected` alone to find main: any branch can be protected.
 */
export function findMainBranch(branches: Branch[] | undefined): Branch | undefined {
  return branches?.find((b) => b.name === 'main')
}

/** Whether this row is main itself (the default database / baseline). */
export function isMainBranch(b: Branch | undefined): boolean {
  return b !== undefined && b.name === 'main'
}

export function isSystemOrigin(origin: Branch['origin']): boolean {
  return origin === 'ingest' || origin === 'system'
}
